/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Not_AssignedInputs */

const en_course_not_assigned = /** @type {(inputs: Course_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course not assigned`)
};

const ja_course_not_assigned = /** @type {(inputs: Course_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースが割り当てられていません`)
};

const fr_course_not_assigned = /** @type {(inputs: Course_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours non assigné`)
};

const de_course_not_assigned = /** @type {(inputs: Course_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs nicht zugewiesen`)
};

/**
* | output |
* | --- |
* | "Course not assigned" |
*
* @param {Course_Not_AssignedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_not_assigned = /** @type {((inputs?: Course_Not_AssignedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Not_AssignedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_not_assigned(inputs)
	if (locale === "ja") return ja_course_not_assigned(inputs)
	if (locale === "fr") return fr_course_not_assigned(inputs)
	return de_course_not_assigned(inputs)
});